import Modal from "react-modal"
import { useState } from "react"

const MyModal = ({ children, isOpen, toggleModal, dir, width, height, backgroundColor }) => {
    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={toggleModal}
                overlayClassName="fixed inset-0 z-10 backdrop-filter backdrop-blur-xl"
                closeTimeoutMS={200}
                style={{
                    content: {
                        direction: dir,
                        maxWidth: width,
                        maxHeight: height,
                        margin: "auto",
                        borderRadius: "10px",
                        backgroundColor: backgroundColor || "unset",
                    },
                }}
                ariaHideApp={false}
            >
                <button
                    type="button"
                    class="absolute top-2 right-3 z-10 text-gray-400 bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center hover:bg-gray-800 hover:text-white"
                    onClick={toggleModal}
                >
                    <svg
                        aria-hidden="true"
                        class="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
                {children}
            </Modal>
        </>
    )
}

export default MyModal
